/**
 * Views and playback time tracker.
 */

import { metrics } from "utils/metrics";

const TRENDING_DURATION = 5000;

class PlaybackTracker {
  private gifId: string|null;
  private startedAt: number|null;
  private context: string | null;

  public constructor() {
    this.gifId = null;
    this.startedAt = null;
    this.context = null;
  }

  public stop(): void {
    if (this.gifId !== null && this.startedAt !== null) {
      const duration = Date.now() - this.startedAt;
      this.sendPlayback(this.gifId, duration, this.context);
    }

    this.gifId = null;
    this.startedAt = null;
  }

  public start(gif: string, context: string | null): void {
    this.stop();

    this.gifId = gif;
    this.startedAt = Date.now();
    this.context = context;

    this.sendView(gif);
  }

  private sendView(gif: string): void {
    console.debug(`[playback] gif ${gif} view.`);
  }

  private sendPlayback(gif: string, duration: number, context: string | null): void {
    console.debug(`[playback] gif ${gif} playback, context=${context} ${duration} ms.`);
    metrics.sendGifPlayback({ gif, duration, context });

    if (duration >= TRENDING_DURATION) {
      metrics.sendMeaningfulGifView({
        gifId: gif,
      });
    }
  }
}

export const playbackTracker = new PlaybackTracker();
